export const SITES_PATH = "/sites";

export function sitePath(id: string): string {
  return `${SITES_PATH}/${encodeURIComponent(id)}`;
}

/** The chrome-free print route that lays the document out as pages and opens "Save as PDF". */
export function sitePrintPath(id: string): string {
  return `${sitePath(id)}/print`;
}
